import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { API, formatApiError } from "@/lib/api";
import { LogoSymbol } from "@/components/Brand";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("loading");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setStatus("error"); setMsg("Link di verifica non valido."); return; }
    axios.post(`${API}/auth/verify-email`, { token })
      .then(() => setStatus("ok"))
      .catch((e) => { setStatus("error"); setMsg(formatApiError(e.response?.data?.detail)); });
  }, [params]);

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center px-6 text-center" data-testid="verify-email-page">
      <LogoSymbol className="h-12" />
      {status === "loading" && <><Loader2 className="w-6 h-6 animate-spin text-blue-500 mt-6" /><p className="mt-3 text-slate-500">Verifica in corso…</p></>}
      {status === "ok" && (
        <>
          <CheckCircle2 className="w-12 h-12 text-emerald-500 mt-6" />
          <h1 className="mt-3 font-serif-display text-2xl text-slate-800">Email confermata!</h1>
          <p className="mt-2 text-slate-500">Il tuo indirizzo è stato verificato con successo.</p>
          <Link to="/dashboard" data-testid="verify-go-dashboard" className="mt-6 rounded-full bg-blue-500 text-white font-semibold px-6 py-3">Vai alla dashboard</Link>
        </>
      )}
      {status === "error" && (
        <>
          <XCircle className="w-12 h-12 text-red-400 mt-6" />
          <h1 className="mt-3 font-serif-display text-2xl text-slate-800">Verifica non riuscita</h1>
          <p className="mt-2 text-slate-500">{msg}</p>
          <Link to="/dashboard/settings" className="mt-6 text-blue-600 font-semibold">Richiedi un nuovo link</Link>
        </>
      )}
    </div>
  );
}
